//src/styles/custom/spacing.js

const spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
  // Function version for dynamic spacing
  get: (multiplier) => multiplier * 8,
};

export default spacing;